export const ROUTES = Object.freeze({
    HOME: '/admin/home',
    PROJECTS: '/admin/projects',
    PROJECT: (id) => `/admin/projects/${id}`,
    WORK: '/admin/work',
    TASK: (id) => `/admin/work/${id}`,
    TEAMS: '/admin/teams',
    TEAM: (id) => `/admin/teams/${id}`,
    REVIEWS: '/admin/reviews',
    REVIEW: (taskId) => `/admin/reviews/${taskId}`,
    DEVICE: '/admin/device',
    LOGIN: '/login',
    UNAUTHORIZED: '/unauthorized',
});

export const SEARCH_DEBOUNCE_MS = 250;
